(function () {
    'use strict';

    angular.module('asys')
        .controller('AngebotController', AngebotController);

    AngebotController.$inject = [
        '$rootScope',
        '$scope',
        '$sce',
        '$log',
        '$q',
        '$modal',
        '$injector',
        '$document',
        '$timeout',
        'lodash',
        'moment',
        'AppConfig',
        'BasisAngebotService',
        'SchluesselWerteUtilsService',
        'AngebotModel',
        'schluesselwerte',
        'angebotSpezifischeWerte',
        'NavigationService',
        'HtmlUtilsService',
        'MiscUtilsService',
        'AlertService',
        'LoadingIndicatorService',
        'FormatUtilsService',
        'AdresseUtilsService',
        'IntegrationService',
        'AngebotUtilsService',
        '$analytics',
        'TrackingUtilsService'
    ];
    function AngebotController($rootScope, $scope, $sce, $log, $q, $modal, $injector, $document, $timeout, _, moment, AppConfig, BasisAngebotService, SchluesselWerteUtilsService, AngebotModel, schluesselwerte, angebotSpezifischeWerte, NavigationService, HtmlUtilsService, MiscUtilsService, AlertService, LoadingIndicatorService, FormatUtilsService, AdresseUtilsService, IntegrationService, AngebotUtilsService, $analytics, TrackingUtilsService) {
        var vm = this,
            druckwege,
            inkassoarten,
            kontoinhaber,
            vorversicherungsarten,
            vorversicherungGekuendigtVon,
            AngebotSpezifischService,
            FilePopupService = $injector.has('FilePopupService') && $injector.get('FilePopupService');

        $log.debug('AngebotController', vm);

        vm.angebotModel = AngebotModel.get() || {};

        AngebotSpezifischService = BasisAngebotService.getDIReference(BasisAngebotService.getAngebotSpezifischNamePrefix(vm.angebotModel.angebot) + 'Service');

        druckwege = BasisAngebotService.getConstant('druckwege', vm.angebotModel.angebot);
        inkassoarten = BasisAngebotService.getConstant('inkassoarten', vm.angebotModel.angebot);
        kontoinhaber = BasisAngebotService.getConstant('kontoinhaber', vm.angebotModel.angebot);
        vorversicherungsarten = BasisAngebotService.getConstant('vorversicherungsarten', vm.angebotModel.angebot);
        vorversicherungGekuendigtVon = BasisAngebotService.getConstant('vorversicherungGekuendigtVon', vm.angebotModel.angebot);
        vm.sw = vm.sw || {};

        if (IntegrationService.getIntegrationParams().subtyp) {
            vm.titleBarTitle = AppConfig.ANGEBOT.produktBezeichnung[IntegrationService.getIntegrationParams().subtyp];
            vm.titleBarSubTitle = AppConfig.ANGEBOT.produktSubText[IntegrationService.getIntegrationParams().subtyp];
        } else if (AngebotSpezifischService.getTitleBarSubTitle) {
            vm.titleBarTitle = AppConfig.ANGEBOT.produktBezeichnung;
            vm.titleBarSubTitle = AngebotSpezifischService.getTitleBarSubTitle(vm.angebotModel.angebot);
        } else {
            vm.titleBarTitle = AppConfig.ANGEBOT.produktBezeichnung;
            vm.titleBarSubTitle = AppConfig.ANGEBOT.produktSubText;
        }
        vm.CONSTANTS = {
            listen: {
                taetigkeitsschluessel: BasisAngebotService.getConstant('taetigkeitsschluessel'),
                druckwege: HtmlUtilsService.createSelectArray(druckwege.vorschau, druckwege.post, druckwege.email),
                inkassoart: HtmlUtilsService.createSelectArray.apply(null, BasisAngebotService.getErlaubteInkassoarten()),
                kontoinhaber: HtmlUtilsService.createSelectArray(kontoinhaber.versicherungsnehmer, kontoinhaber.anderePerson)
            },
            druckwege: _.toArray(druckwege),
            inkassoarten: _.toArray(inkassoarten),
            kontoinhaber: _.toArray(kontoinhaber),
            vorversicherungsarten: _.toArray(vorversicherungsarten),
            vorversicherungGekuendigtVon: _.toArray(vorversicherungGekuendigtVon),
            kontoinhaberVn: kontoinhaber.versicherungsnehmer,
            kontoinhaberAnderePerson: kontoinhaber.anderePerson,
            inkassoartAbbucher: inkassoarten.abbucher,
            inkassoartRechnung: inkassoarten.rechnung,
            inkassoartPayPal: inkassoarten.paypal,
            inkassoartKreditkarte: inkassoarten.kreditkarte,
            inkassoartSofortueberweisung: inkassoarten.sofortueberweisung,
            vorversicherungUnternehmen: vorversicherungsarten.unternehmen,
            vorversicherungFremdversicherung: vorversicherungsarten.fremdversicherung,
            vorversicherungGekuendigtVonVersicherer: vorversicherungGekuendigtVon.versicherer,
            vorversicherungGekuendigtVonVersicherungsnehmer: vorversicherungGekuendigtVon.versicherungsnehmer,
            monate: FormatUtilsService.monthNames,
            plzAntragstellerEingabeImAngebot: AppConfig.ANGEBOT.plzAntragstellerEingabeImAngebot,
            telefon: AppConfig.APP.telefon,
            telefonDirektion: AppConfig.APP.telefonDirektion,
            telefonRisikopruefung: AppConfig.APP.telefonRisikopruefung,
            telefonKundenservice: AppConfig.APP.telefonKundenservice
        };

        if (_.isFunction(AngebotSpezifischService.getConstants)) {
            vm.CONSTANTS = _.merge({}, vm.CONSTANTS, AngebotSpezifischService.getConstants());
        }
        vm.AlertService = AlertService;
        vm.FilePopupService = FilePopupService;
        vm.AppConfig = AppConfig;
        vm.isAngebotAenderbar = isAngebotAenderbar;
        vm.kopiereAngebot = kopiereAngebot;
        vm.speichereAngebot = speichereAngebot;
        vm.erstelleNeuesAngebot = erstelleNeuesAngebot;
        vm.isErsatzgeschaeft = isErsatzgeschaeft;
        vm.isKonditionVorhanden = isKonditionVorhanden;
        vm.isBestandskunde = isBestandskunde;
        vm.getArbeitgeberSw = getArbeitgeberSw;
        vm.setSubtyp = setSubtyp;
        vm.isAppModus = isAppModus;
        vm.onClickFieldset = onClickFieldset;
        vm.isTitleBarSichtbar = isTitleBarSichtbar;

        activate();

        function activate() {
            var status = BasisAngebotService.getStatus(vm.angebotModel.angebot) || 'A',
                paymentState = IntegrationService.getIntegrationParams().paymentState;

            if (isAppModus()) {
                $log.info('*****************\nApp-Modus aktiv\n*****************');
            }
            vm.currentDateYYYYMMDD = moment().format(AppConfig.API.dateFormat);
            vm.currentDateMinus18yearsYYYYMMDD = moment().subtract(18, 'years').format(AppConfig.API.dateFormat);
            vm.currentDateMinus120yearsYYYYMMDD = moment().subtract(120, 'years').format(AppConfig.API.dateFormat);
            vm.currentDatePlus10yearsYYYYMMDD = moment().add(10, 'years').format(AppConfig.API.dateFormat);
            vm.vertragHauptfaelligkeit = AppConfig.ANGEBOT.vertragHauptfaelligkeit;
            vm.hinweisBeitragsrueckerstattung = AppConfig.ANGEBOT.beitragsrueckerstattungHinweis;
            vm.isKopierenErlaubt = _.isNil(_.get(vm.angebotModel, 'wurdeGeladen')) ? true : !_.get(vm.angebotModel, 'wurdeGeladen');
            vm.AngebotSpezifischService = AngebotSpezifischService;
            setSubtyp();

            if (_.get(vm.angebotModel, 'wurdeGeladen')) {
                vm.tarifauskunftsdatumChangedManually = true;
            }

            AngebotUtilsService.setRedirectUrlAfterPksLogin(vm.angebotModel.angebot);

            if (angular.isFunction(AngebotSpezifischService.getTestsiegelFilterJsonPath)) {
                vm.testsiegelFilterJsonPath = AngebotSpezifischService.getTestsiegelFilterJsonPath(vm.angebotModel);
            }

            AdresseUtilsService.getAdressen().then(function (adressen) {
                vm.adressenAntragsteller = adressen;
                vm.postleitzahlenAntragsteller = AdresseUtilsService.getUniquePostleitzahlen(adressen);
            });

            BasisAngebotService.isKontaktErlaubtPartner(vm.angebotModel).then(function (kontaktErlaubt) {
                vm.isKontaktErlaubtPartner = kontaktErlaubt;
            }).catch(function () {
                vm.isKontaktErlaubtPartner = true;
            });

            vm.antragstellerAenderbarMap = AngebotUtilsService.getAntragstellerDatenAenderbarMap(vm.angebotModel.angebot);

            BasisAngebotService.getGlobals(vm.angebotModel).then(function (globals) {
                _.merge(vm, globals);
            });
            if (MiscUtilsService.isNotEmpty(schluesselwerte)) {
                _.merge(vm.sw, schluesselwerte);
            }

            SchluesselWerteUtilsService.fetch('arbeitgeber', {
                params: {
                    sort: 'wwwBezeichnung'
                }
            }).then(function (arbeitgeber) {
                vm.sw.arbeitgeber = arbeitgeber;
            }).catch(function () {
            });

            SchluesselWerteUtilsService.fetch('berufe', {
                params: {
                    berufFilter: 'EINGESCHRAENKT'
                }
            }).then(function (berufeEingeschraenkt) {
                vm.sw.berufeEingeschraenkt = berufeEingeschraenkt;
            }).catch(function () {
            });
            SchluesselWerteUtilsService.fetch('anreden').then(function (anreden) {
                vm.sw.anreden = anreden;
            }).catch(function () {
            });

            SchluesselWerteUtilsService.fetch('titel').then(function (titel) {
                vm.sw.titel = titel;
            }).catch(function () {
            });

            SchluesselWerteUtilsService.fetch('laendercodes', null, 'kontoverbindungen/').then(function (laender) {
                vm.sw.laender = laender;
            }).catch(function () {
            });

            if (AppConfig.ANGEBOT.blaulichtVorhanden) {
                SchluesselWerteUtilsService.fetch('blaulicht').then(function (blaulicht) {
                    vm.sw.blaulicht = blaulicht;
                }).catch(function () {
                });
            }
            if (_.isFunction(AngebotSpezifischService.getSchluesselwerte)) {
                AngebotSpezifischService.getSchluesselwerte(vm.angebotModel.angebot).then(function (angebotSpezifischeSws) {
                    _.merge(vm.sw, angebotSpezifischeSws);
                });
            }
            if (MiscUtilsService.isNotEmpty(angebotSpezifischeWerte)) {
                _.merge(vm, angebotSpezifischeWerte);
            }

            if (_.isFunction(AngebotSpezifischService.getAngebotSpezifischeWerte)) {
                AngebotSpezifischService.getAngebotSpezifischeWerte().then(function (angebotSpezifischeWerte) {
                    _.merge(vm, angebotSpezifischeWerte);
                });
            }

            if (_.isFunction(AngebotSpezifischService.showMeldungen)) {
                AngebotSpezifischService.showMeldungen(vm.angebotModel.angebot);
            }

            if (!_.includes([
                AppConfig.ANGEBOT.status.ANGEBOT,
                AppConfig.ANGEBOT.status.GEDRUCKT,
                AppConfig.ANGEBOT.status.GEDRUCKT_TEILWEISE_AENDERBAR,
                AppConfig.ANGEBOT.status.ANTRAG_DRUCK
            ], status)) {
                $scope.$emit('iplusjs:addAlert', {
                    message: $sce.trustAsHtml(AppConfig.MESSAGES.angebotNichtAenderbarAntrag),
                    type: 'info',
                    permanent: true,
                    id: 'ANG_NICHT_AENDERBAR_ANTRAG'
                });
            }

            $analytics.setUserProperties({
                hurra: {
                    orderId: AngebotUtilsService.getUid(vm.angebotModel)
                }
            });

            if (!_.includes(_.get($rootScope, 'tracking'), 'hurra.lead') && MiscUtilsService.isEmpty(paymentState)) {
                $analytics.eventTrack('lead', {
                    trackingProvider: 'hurra',
                    category_id: 'ICISPlus-Angebot',
                    product_id: BasisAngebotService.getAngebotstyp(vm.angebotModel.angebot),
                    u5: AngebotUtilsService.getTrackingParameter(vm.angebotModel.angebot, 'hurra', 'lead', 'u5', 'lead')
                });

                $rootScope.tracking.push('hurra.lead');
            }

            $scope.$on('$stateChangeSuccess', function (event, toState, toParams, fromState, fromParams) {
                vm.cssClassMainActive = AppConfig.APP[AppConfig.APP.defaultCssClassMainWidthContainer];
                vm.cssClassMainWidthContainer = AppConfig.APP[AppConfig.APP.defaultCssClassMainWidthContainer];
            });

            $scope.$on('iplusjs:showModalAngebotNichtAenderbar', function () {
                showModalAngebotNichtAenderbar();
            });
        }
        function isAngebotAenderbar(type) {
            return BasisAngebotService.isAngebotAenderbar(vm.angebotModel.angebot, type);
        }
        function kopiereAngebot(ignoreBeitraegeVorhanden, speichern, toParams, geaendertesAngebot) {
            return $q(function (resolve, reject) {
                ignoreBeitraegeVorhanden = _.isNil(ignoreBeitraegeVorhanden) ? true : ignoreBeitraegeVorhanden;
                speichern = _.isNil(speichern) ? true : speichern;

                LoadingIndicatorService.addInProgress();

                var startStep = BasisAngebotService.getStartStep(vm.angebotModel.angebot, ignoreBeitraegeVorhanden),
                    promiseFunc = speichern ? BasisAngebotService.speichere : function () {
                        return $q(function (resolve) {
                            resolve([]);
                        });
                    };

                promiseFunc(vm.angebotModel).then(function (data) {
                    if (speichern) {
                        $log.debug('AngebotController.kopiereAngebot BasisAngebotService.speichere SUCCESS');
                    }

                    if (data && data.angebot) {
                        vm.angebotModel.angebot = angular.merge({}, data.angebot);
                    }

                    BasisAngebotService.kopiereAngebot(vm.angebotModel)
                        .then(function (angebotModel) {
                            $scope.$emit('iplusjs:removeAllAlerts');
                            TrackingUtilsService.resetTrackingCache('wgv');
                            FilePopupService && FilePopupService.removeBlockedFile();

                            vm.angebotModel = angebotModel;

                            if (geaendertesAngebot) {
                                vm.angebotModel.angebot = angular.merge({}, vm.angebotModel.angebot, geaendertesAngebot);
                            }

                            $analytics.setUserProperties({
                                hurra: {
                                    orderId: AngebotUtilsService.getUid(vm.angebotModel)
                                }
                            });
                            NavigationService.setDisabled(startStep, false);
                            NavigationService.setFollowingDisabled(true, startStep);
                            NavigationService.goToStep(startStep, toParams, {
                                reload: true,
                                location: 'replace'
                            });
                        }).catch(function (error) {
                            $log.error('AngebotController.kopiereAngebot BasisAngebotService.kopiereAngebot FAILURE', error);
                        }).finally(function () {
                            LoadingIndicatorService.removeInProgress();
                            resolve(vm.angebotModel);
                            $timeout(function () {
                                focusElementAfterCloseModalNichtAenderbar();
                            });
                        });
                }).catch(function (error) {
                    if (speichern) {
                        $log.error('AngebotController.kopiereAngebot BasisAngebotService.speichere FAILURE', error);
                    }
                    LoadingIndicatorService.removeInProgress();
                    reject();
                    $timeout(function () {
                        focusElementAfterCloseModalNichtAenderbar();
                    });
                });
            });
        }
        function speichereAngebot() {
            return $q(function (resolve) {
                LoadingIndicatorService.addInProgress();
                BasisAngebotService.speichere(vm.angebotModel).then(function (data) {
                    $log.debug('AngebotController.speichereAngebot BasisAngebotService.speichere SUCCESS');

                    if (data.angebot) {
                        vm.angebotModel.angebot = angular.merge({}, data.angebot);
                    }
                }).catch(function (error) {
                    $log.error('AngebotController.speichereAngebot BasisAngebotService.speichere FAILURE', error);
                }).finally(function () {
                    LoadingIndicatorService.removeInProgress();
                    resolve();
                });
            });
        }
        function erstelleNeuesAngebot() {
            var params = {
                    pathParameters: {},
                    queryParameters: {}
                },
                tarifauskunftsdatum = BasisAngebotService.getTarifauskunftsdatum(vm.angebotModel.angebot);

            params.queryParameters.gevoId = _.get(vm.angebotModel, 'angebot.gevoId');
            if (moment(tarifauskunftsdatum, AppConfig.API.dateFormat).isBefore(moment())) {
                tarifauskunftsdatum = null;
            }

            LoadingIndicatorService.addInProgress();

            return AngebotModel.erstelleNeuesAngebot(tarifauskunftsdatum, null, params).then(function (angebotModel) {
                $log.debug('AngebotController.erstelleNeuesAngebot SUCCESS', angebotModel);
                TrackingUtilsService.resetTrackingCache('wgv');

                vm.angebotModel = angebotModel;

                $analytics.setUserProperties({
                    hurra: {
                        orderId: AngebotUtilsService.getUid(vm.angebotModel)
                    }
                });
            }).catch(function (error) {
                $log.error('AngebotController.erstelleNeuesAngebot ERROR', error);
            }).finally(function () {
                var startStep = BasisAngebotService.getStartStep(vm.angebotModel.angebot, true);

                $analytics.eventTrack('link', {
                    target: 'Angebot-neu'
                });

                $rootScope.tracking = [];

                activate();

                $scope.$emit('iplusjs:removeAllAlerts');
                FilePopupService && FilePopupService.removeBlockedFile();
                NavigationService.setFollowingDisabled(true, startStep);
                NavigationService.goToStep(startStep, null, {
                    reload: true
                });

                LoadingIndicatorService.removeInProgress();

                $timeout(function () {
                    focusElementAfterCloseModalNichtAenderbar();
                });
            });
        }
        function isErsatzgeschaeft() {
            return BasisAngebotService.isErsatzgeschaeft(vm.angebotModel.angebot);
        }
        function isKonditionVorhanden(konditionscodeId) {
            return BasisAngebotService.isKonditionVorhanden(vm.angebotModel.angebot, konditionscodeId);
        }
        function isBestandskunde() {
            return BasisAngebotService.isBestandskunde(vm.angebotModel.angebot);
        }
        function getArbeitgeberSw(filterByAntragstellerMGA) {
            return MiscUtilsService.mergeUniq(_.filter(_.get(vm.sw, 'arbeitgeber'), function (arbeitgeber) {
                return filterByAntragstellerMGA ? arbeitgeber.mitgliedsart === _.get(vm.angebotModel.angebot, 'antragsteller.mitgliedsart.wert') : true;
            }), _.get(vm.angebotModel.angebot, 'antragsteller.arbeitgeber'), 'wert');
        }
        function setSubtyp() {
            vm.subtyp = IntegrationService.getIntegrationParams().subtyp;
        }
        function isAppModus() {
            return MiscUtilsService.isAppModus();
        }
        function onClickFieldset(event) {
            var elem = event.target,
                path;

            path = event.path || (event.composedPath && event.composedPath()) || HtmlUtilsService.composedPath(elem);

            if ((HtmlUtilsService.hasElement(path, ['IPLUSJS-TOOLTIP-CONTENT']) || HtmlUtilsService.hasClass(path, 'ipjs-no-copy-check')) && !HtmlUtilsService.hasClass([elem], 'ipjs-copy-check')) {
                return;
            }

            showModalAngebotNichtAenderbar();
        }

        function showModalAngebotNichtAenderbar() {
            var modalAngebotNichtAenderbar,
                kopierenBlockiert,
                veralteterTarif;

            if (isAngebotAenderbar('ANGEBOT') || !isAngebotAenderbar('ANTRAG')) {
                return;
            }

            kopierenBlockiert = _.get(vm.angebotModel.angebot, 'kopierenBlockiert') === true;
            veralteterTarif = _.get(vm.angebotModel.angebot, 'veralteterTarif') === true;

            modalAngebotNichtAenderbar = $modal.open({
                templateUrl: 'modal/modalAngebotNichtAenderbar.html',
                windowClass: 'medium',
                controller: 'ModalAngebotNichtAenderbarController',
                controllerAs: 'modalVm',
                resolve: { /* @ngInject */
                    content: [function () {
                        return {
                            body: (function () {
                                var bodyContent;

                                if (angular.isFunction(AngebotSpezifischService.getModalAngebotNichtAenderbarContent)) {
                                    bodyContent = AngebotSpezifischService.getModalAngebotNichtAenderbarContent(vm.angebotModel.angebot);
                                } else {
                                    bodyContent = kopierenBlockiert ? AppConfig.MESSAGES.angebotNichtAenderbarAngebotKopierenBlockiert : AppConfig.MESSAGES.angebotNichtAenderbarAngebot;

                                    bodyContent = veralteterTarif ? null : bodyContent;
                                }

                                return bodyContent;
                            })()
                        };
                    }],
                    type: [function () {
                        return kopierenBlockiert ? 'NEU' : 'KOPIEREN';
                    }]
                }
            });

            modalAngebotNichtAenderbar.result.then(function () {
                if (kopierenBlockiert) {
                    return erstelleNeuesAngebot();
                } else {
                    return kopiereAngebot();
                }
            }).catch(function (error) {
                focusElementAfterCloseModalNichtAenderbar();
            });
        }

        function isTitleBarSichtbar() {
            return NavigationService.getActive().group !== 'ABSCHLUSS';
        }

        function focusElementAfterCloseModalNichtAenderbar() {
            var focusElementAfterCloseModalNichtAenderbar = $document[0].querySelector('.logo a');

            focusElementAfterCloseModalNichtAenderbar && focusElementAfterCloseModalNichtAenderbar.focus();
        }
    }
})();
